import { getData } from '@/utils/axiosUtils';

const getDialPadLoginLink = async (
    companyId,
    location = window.location.href,
) => {
    return await getData(
        `/company/${companyId}/DialPadLoginLink?domain=${location}`,
    );
};

export default getDialPadLoginLink;
